import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.updateMarketingCampaigns
)

export const selectIsToggleCampaignModalOpen = createSelector(
    baseSelector,
    (state) => state.isToggleCampaignModalOpen
)

export const selectOnToggle = createSelector(
    baseSelector,
    (state) => state.onToggle
)

export const selectCampaign = createSelector(
    baseSelector,
    (state) => state.campaign
)

export const selectIsPostResultsModalOpen = createSelector(
    baseSelector,
    (state) => state.isPostResultsModalOpen
)